import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import { SuccessSnackbar } from '../../components/snackbar/success-snackbar/success-snackbar';
import { ErrorSnackbar } from '../../components/snackbar/error-snackbar/error-snackbar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private readonly snackbar: MatSnackBar) {}

  duration: number = 5000;
  setDuration = (newDuration: number) => {
    this.duration = newDuration;
    return this;
  };

  success(msg: string) {
    this.snackbar.openFromComponent(SuccessSnackbar, {
      data: { message: msg },
      panelClass: ['success-snackbar'],
      duration: 5000,
    });
    return this;
  }

  error(msg: string) {
    this.snackbar.openFromComponent(ErrorSnackbar, {
      data: { message: msg },
      panelClass: ['error-snackbar'],
      duration: 5000,
    });
    return this;
  }
}
